import type { IPricingComparisonFeature } from '../../types';

import { Box, Divider } from '@shopify/polaris';
import { FeatureTitle } from './FeatureTitle';
import { PlanDetail } from './PlanDetail';
import { Fragment, useMemo } from 'react';

export const PlanCompareTable = ({
  features,
  isChildren,
}: {
  features: IPricingComparisonFeature[];
  isChildren?: boolean;
}) => {
  const MemoizedFeaturesList = useMemo(() => {
    return features.map((feature, index) => {
      const { title, plansDetail, tooltipKey, badgeProps } = feature;

      return (
        <Fragment key={index}>
          <PlanCompareTable.Row hiddenDivider={index === 0}>
            <PlanCompareTable.Cell hiddenPaddingInline>
              <FeatureTitle
                title={title}
                tooltipKey={tooltipKey}
                fontWeight={isChildren ? 'regular' : 'medium'}
                boxProps={{ paddingInlineStart: isChildren ? '600' : '0' }}
                badgeProps={badgeProps}
              />
            </PlanCompareTable.Cell>

            <PlanDetail detail={plansDetail} />
          </PlanCompareTable.Row>

          {feature.children && (
            <>
              <Box paddingInline="400">
                <Divider />
              </Box>
              <PlanCompareTable features={feature.children} isChildren={true} />
            </>
          )}
        </Fragment>
      );
    });
  }, [features, isChildren]);

  return <Box as="div">{MemoizedFeaturesList}</Box>;
};

const Row = ({
  children,
  hiddenDivider,
  hiddenPaddingInline,
}: {
  children: React.ReactNode;
  hiddenDivider?: boolean;
  hiddenPaddingInline?: boolean;
}) => {
  return (
    <Box paddingInline={hiddenPaddingInline ? '0' : '400'}>
      {!hiddenDivider && <Divider />}

      <div className="gp-pricing-sticky-grid">{children}</div>
    </Box>
  );
};
PlanCompareTable.Row = Row;

const Cell = ({
  children,
  hiddenPaddingInline,
}: {
  children: React.ReactNode;
  hiddenPaddingInline?: boolean;
}) => (
  <Box paddingBlock="400" paddingInline={hiddenPaddingInline ? '0' : '300'}>
    <div className="flex h-full">{children}</div>
  </Box>
);
PlanCompareTable.Cell = Cell;
